module.exports = __webpack_public_path__ + "static/media/addIconPurpleWithBg.c5a859e3.png";